import { OutboundMessageStatus } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { i18next } from '@frontend/i18n';

export type MessageStatusColorTone =
  | 'critical'
  | 'eggplant'
  | 'indigo'
  | 'neutral'
  | 'neutralMuted'
  | 'neutralStrong'
  | 'primary'
  | 'tangerine'
  | 'warning';

// Canonical grouped status behavior shared by queue hooks and status colors.
export const defaultGroupedStatusMap: Partial<Record<OutboundMessageStatus, OutboundMessageStatus>> = {
  [OutboundMessageStatus.DELIVERED]: OutboundMessageStatus.DELIVERED,
  [OutboundMessageStatus.SENT]: OutboundMessageStatus.DELIVERED,
  [OutboundMessageStatus.ERROR]: OutboundMessageStatus.ERROR,
  [OutboundMessageStatus.INVALID_DESTINATION]: OutboundMessageStatus.INVALID_DESTINATION,
  [OutboundMessageStatus.NOT_ANSWERED]: OutboundMessageStatus.NOT_ANSWERED,
  [OutboundMessageStatus.CANCELED]: OutboundMessageStatus.NOT_SENT,
  [OutboundMessageStatus.DELETED]: OutboundMessageStatus.NOT_SENT,
  [OutboundMessageStatus.NOT_DELIVERED]: OutboundMessageStatus.NOT_SENT,
  [OutboundMessageStatus.NOT_SENT]: OutboundMessageStatus.NOT_SENT,
  [OutboundMessageStatus.SUPPRESSED]: OutboundMessageStatus.NOT_SENT,
  [OutboundMessageStatus.OPTED_OUT]: OutboundMessageStatus.OPTED_OUT,
  [OutboundMessageStatus.PAUSED]: OutboundMessageStatus.PAUSED,
  [OutboundMessageStatus.IN_PROCESS]: OutboundMessageStatus.SCHEDULED,
  [OutboundMessageStatus.SCHEDULED]: OutboundMessageStatus.SCHEDULED,
  [OutboundMessageStatus.SCHEDULED_RETRY]: OutboundMessageStatus.SCHEDULED,
  [OutboundMessageStatus.VOICEMAIL]: OutboundMessageStatus.VOICEMAIL,
};

// displayed status label to the end user
export const groupedStatusDisplayLabels: Partial<Record<OutboundMessageStatus, string>> = {
  [OutboundMessageStatus.DELIVERED]: i18next.t('Delivered', { ns: 'messages' }),
  [OutboundMessageStatus.ERROR]: i18next.t('Error', { ns: 'messages' }),
  [OutboundMessageStatus.INVALID_DESTINATION]: i18next.t('Invalid Destination', { ns: 'messages' }),
  [OutboundMessageStatus.NOT_ANSWERED]: i18next.t('Not Answered', { ns: 'messages' }),
  [OutboundMessageStatus.NOT_SENT]: i18next.t('Not Sent', { ns: 'messages' }),
  [OutboundMessageStatus.OPTED_OUT]: i18next.t('Opted Out', { ns: 'messages' }),
  [OutboundMessageStatus.PAUSED]: i18next.t('Paused', { ns: 'messages' }),
  [OutboundMessageStatus.SCHEDULED]: i18next.t('Scheduled', { ns: 'messages' }),
  [OutboundMessageStatus.VOICEMAIL]: i18next.t('Voicemail', { ns: 'messages' }),
};

// list of grouped successful messages statuses (e.g. shown in the auto suppression card)
export const successfulGroupedStatuses = [
  OutboundMessageStatus.DELIVERED,
  OutboundMessageStatus.NOT_ANSWERED,
  OutboundMessageStatus.VOICEMAIL,
];

// list of grouped failed messages statuses (e.g. shown in the auto suppression card)
export const failedGroupedStatuses = [
  OutboundMessageStatus.ERROR,
  OutboundMessageStatus.INVALID_DESTINATION,
  OutboundMessageStatus.NOT_SENT,
  OutboundMessageStatus.OPTED_OUT,
];

export const groupedStatusColorTones: Partial<Record<OutboundMessageStatus, MessageStatusColorTone>> = {
  [OutboundMessageStatus.DELIVERED]: 'primary',
  [OutboundMessageStatus.ERROR]: 'critical',
  [OutboundMessageStatus.INVALID_DESTINATION]: 'neutralStrong',
  [OutboundMessageStatus.NOT_ANSWERED]: 'indigo',
  [OutboundMessageStatus.NOT_SENT]: 'eggplant',
  [OutboundMessageStatus.OPTED_OUT]: 'neutralMuted',
  [OutboundMessageStatus.PAUSED]: 'neutral',
  [OutboundMessageStatus.SCHEDULED]: 'warning',
  [OutboundMessageStatus.VOICEMAIL]: 'tangerine',
};
